// An operator's choice, on the structural history card, of the report version the
// structural assessment relies on. Mirrors lambda_handlers/api/stateful_agents/portfolio/
// structural_rely_on.py. See docs/Y2026-Q4/design-structural-history.md.
import { useMutation, useQueryClient } from "react-query";

import type { PostJsonError } from "../http/postJson";
import { useAgentsHttp } from "../useAgentsHttp";
import { QK } from "../queryKeys";

export interface StructuralRelyOnBody {
  project_id: string;
  /** The version chosen, by its entry id. */
  entry_id: string;
  note: string;
  actor_email: string;
}

const MOVED =
  "Not saved: Building readiness's actions changed while you chose. The page now shows " +
  "the latest; choose again.";

export const useStructuralRelyOn = () => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<{ entry_id: string }, Error, StructuralRelyOnBody>(
    (body) =>
      http<{ entry_id: string }>("/projects/structural-history/rely-on", body).catch(
        (err: PostJsonError) => {
          throw err.status === 409 ? new Error(MOVED) : err;
        },
      ),
    {
      onSettled: () => {
        void qc.invalidateQueries([QK.projectAgentStatus]);
        void qc.invalidateQueries([QK.dashboard]);
      },
    },
  );
};
